// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class ImageAspectRatio extends Vue {
  @Prop({ default: "16-9" })
  public ratio!: string;

  @Prop({ default: false })
  public isWrappingLightbox!: boolean;

  get lightboxClass() {
    if (this.isWrappingLightbox) {
      return "image-aspect-ratio--lightbox";
    } else {
      return "image-aspect-ratio--image";
    }
  }

  get ratioClass() {
    return "image-aspect-ratio__" + this.ratio;
  }
}
